module.exports = __webpack_public_path__ + "img/gmail.deda33ae.svg";